import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { X, Check, Zap } from 'lucide-react';

const UpgradeModal = ({ onClose }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onClose();
    navigate('/perfil?tab=assinatura');
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" data-testid="upgrade-modal">
      <Card className="max-w-4xl w-full rounded-3xl p-8 relative max-h-[90vh] overflow-y-auto">
        <button
          data-testid="close-modal-button"
          onClick={onClose}
          className="absolute top-6 right-6 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
        >
          <X className="w-5 h-5 text-gray-600" />
        </button>

        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-orange-600 mb-4">
            <Zap className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            Desbloqueie Todo o Potencial
          </h2>
          <p className="text-gray-600">
            Faça upgrade para o Profissional e tenha acesso completo
          </p>
        </div>

        {/* Comparison Table */}
        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* FREE Plan */}
          <Card className="p-6 rounded-2xl border-2 border-gray-200">
            <div className="mb-4">
              <h3 className="text-xl font-bold text-gray-900">Essencial</h3>
              <p className="text-3xl font-bold text-gray-900 mt-2">R$ 0</p>
              <p className="text-sm text-gray-500">para sempre</p>
            </div>

            <ul className="space-y-3">
              <li className="flex items-start">
                <Check className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-700">Até 20 lembretes</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-700">Alertas por e-mail</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-700">WhatsApp automático</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-700">QR Code por cliente</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-700">Painel de controle</span>
              </li>
              <li className="flex items-start">
                <X className="w-5 h-5 text-red-400 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Envio manual de WhatsApp</span>
              </li>
              <li className="flex items-start">
                <X className="w-5 h-5 text-red-400 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Importação CSV/PDF</span>
              </li>
              <li className="flex items-start">
                <X className="w-5 h-5 text-red-400 mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">Suporte prioritário</span>
              </li>
            </ul>
          </Card>

          {/* PRO Plan */}
          <Card className="p-6 rounded-2xl border-2 border-primary bg-gradient-to-br from-orange-50 to-white relative overflow-hidden">
            <div className="absolute top-4 right-4">
              <span className="inline-block px-3 py-1 rounded-full bg-primary text-white text-xs font-medium">
                RECOMENDADO
              </span>
            </div>

            <div className="mb-4">
              <h3 className="text-xl font-bold text-gray-900">Profissional</h3>
              <div className="flex items-baseline gap-1 mt-2">
                <span className="text-sm text-gray-500">R$</span>
                <span className="text-4xl font-bold text-primary">19</span>
                <span className="text-xl font-bold text-primary">,99</span>
              </div>
              <p className="text-sm text-gray-600">por mês</p>
            </div>

            <ul className="space-y-3">
              <li className="flex items-start">
                <Check className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900">Contratos ilimitados</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900">Alertas por e-mail</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900">Alertas por WhatsApp automáticos</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900">Envio manual de WhatsApp</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900">Painel de controle</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900">QR Code por cliente</span>
              </li>
              <li className="flex items-start">
                <Check className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" />
                <span className="text-sm font-medium text-gray-900">Importação CSV/PDF</span>
              </li>
            </ul>

            <Button
              data-testid="upgrade-pro-button"
              onClick={handleUpgrade}
              className="w-full mt-6 rounded-2xl h-11 bg-primary hover:bg-primary-hover shadow-lg"
            >
              Assinar Agora — R$ 19,99/mês
            </Button>
          </Card>
        </div>

        {/* Benefits */}
        <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-6 border border-orange-100">
          <h3 className="font-bold text-gray-900 mb-3">Por que fazer upgrade?</h3>
          <div className="grid md:grid-cols-3 gap-4 text-sm text-gray-700">
            <div>
              <p className="font-medium mb-1">💬 WhatsApp Manual</p>
              <p className="text-xs text-gray-600">Envie mensagens avulsas para seus clientes</p>
            </div>
            <div>
              <p className="font-medium mb-1">📋 Importação em massa</p>
              <p className="text-xs text-gray-600">Importe clientes via CSV ou PDF</p>
            </div>
            <div>
              <p className="font-medium mb-1">🚀 Crescimento Ilimitado</p>
              <p className="text-xs text-gray-600">Sem limites de lembretes cadastrados</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default UpgradeModal;
